import {formattedPropertyModel} from '@wallaby-ui/core';
import {filter, forEach, includes, isEmpty, pickBy} from 'lodash';

import {SearchTypeViews} from './search_type_views';

export const CONFIGURATION_CONFIG = 'config';
export const CONFIGURATION_DOCUMENT = 'document';
export const CONFIGURATION_PROPERTIES = 'properties';
const CONFIGURATION_VIEWS = 'views';
export const CONFIGURATION_VIEWS_DEFAULT = 'default';

export class DocumentConfig {
  static initDocumentProperties(rawDocumentProperties) {
    const documentProperties = [];
    if (rawDocumentProperties) {
      forEach(rawDocumentProperties, (property) => {
        documentProperties.push(
          new formattedPropertyModel.FormattedProperty(property)
        );
      });
    }
    return documentProperties;
  }

  static initDocumentPropertiesMap(documentProperties) {
    const result = {};

    forEach(documentProperties, (property) => {
      result[property.getProperty()] = property;
    });
    return result;
  }

  static filterPropertiesByView(properties, views, viewId = 'document') {
    let propertiesByView = properties;
    if (!isEmpty(views)) {
      if (!isEmpty(views.getView(viewId)) && views.getView(viewId).getItems()) {
        // get properties only from the wanted view
        const view = views.getView(viewId).getItems();
        propertiesByView = filter(properties, (property) =>
          includes(view, property.getProperty())
        );
        // if viewId not found in config, use default
      } else if (
        !isEmpty(views.getView(CONFIGURATION_VIEWS_DEFAULT)) &&
        views.getView(CONFIGURATION_VIEWS_DEFAULT).getItems()
      ) {
        const view = views.getView(CONFIGURATION_VIEWS_DEFAULT).getItems();
        propertiesByView = filter(properties, (property) =>
          includes(view, property.getProperty())
        );
      }
    }
    return propertiesByView;
  }

  static filterPropertiesMapByView(properties, views, viewId = 'document') {
    let propertiesMapByView = properties;
    if (
      !isEmpty(views) &&
      !isEmpty(views.getView(viewId)) &&
      views.getView(viewId).getItems()
    ) {
      // get properties only from the wanted view
      const view = views.getView(viewId).getItems();
      propertiesMapByView = pickBy(properties, (property) =>
        includes(view, property.getProperty())
      );
    }
    return propertiesMapByView;
  }

  constructor(rawData = {}) {
    this.rawData = {...rawData};
    this.documentProperties = [];
    this.documentPropertiesMap = {};
    this.loaded = false;
    if (!isEmpty(this.rawData)) {
      const rawConfiguration = this.rawData[CONFIGURATION_CONFIG];
      if (
        rawConfiguration &&
        rawConfiguration[CONFIGURATION_DOCUMENT] &&
        rawConfiguration[CONFIGURATION_DOCUMENT][CONFIGURATION_PROPERTIES]
      ) {
        this.views = new SearchTypeViews(
          this.rawData[CONFIGURATION_CONFIG][CONFIGURATION_VIEWS]
        );
        this.documentProperties = DocumentConfig.initDocumentProperties(
          rawConfiguration[CONFIGURATION_DOCUMENT][CONFIGURATION_PROPERTIES]
        );
        this.documentPropertiesMap = DocumentConfig.initDocumentPropertiesMap(
          this.documentProperties
        );
      }
      this.loaded = true;
    }
  }

  getViews() {
    return this.views;
  }

  getPropertiesByView(viewId = 'document') {
    return DocumentConfig.filterPropertiesByView(
      this.getDocumentProperties(),
      this.getViews(),
      viewId
    );
  }

  getPropertiesMapByView(viewId = 'document') {
    return DocumentConfig.filterPropertiesMapByView(
      this.getDocumentPropertiesMap(),
      this.getViews(),
      viewId
    );
  }

  getDocumentPropertyByView(propertyName, viewId = 'document') {
    return this.getPropertiesMapByView(viewId)[propertyName];
  }

  getDocumentProperties() {
    return this.documentProperties;
  }

  getDocumentPropertiesMap() {
    return this.documentPropertiesMap;
  }

  getDocumentProperty(propertyName) {
    return this.documentPropertiesMap[propertyName];
  }

  isLoaded() {
    return this.loaded;
  }
}

export default {DocumentConfig};
